/* This file was generated automatically. Do not edit manually. */

import * as Types from '../types';
import { RestApiOptions } from './types';

export const createDepositledgerRepository = (options: RestApiOptions): Types.DepositledgerRepository => ({
    async getAll(params, requestOptions) {
        return options.request('/depositledger/getAll', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async getBalance(params, requestOptions) {
        return options.request('/depositledger/getBalance', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
});
